<template>
  <div>
    <v-select
      type="number"
      :items="years"
      label="Select a Year"
      v-model="selectedYear"
      @change="onSelectedYearChanged"
    ></v-select>
  </div>
</template>

<script>
import store from '@/store/index.js'

export default {
  name: 'year-select',
  props: ['label'],

  store: store,

  data: () => ({
    years: [2015, 2016, 2017, 2018, 2019, 2020],
    selectedYear: new Date().getFullYear(),
  }),

  created() {
    var association = this.$store.getters.getAssociation
    var firstYear = 2015
    if (association.startYear) {
      firstYear = association.startYear
    }
    var lastYear = new Date().getFullYear()
    this.selectedYear = lastYear
    this.years = []
    for (var year = firstYear; year <= lastYear; year++) {
      this.years.push(year)
    }
  },

  methods: {
    onSelectedYearChanged() {
      this.$emit('yearChanged', this.selectedYear)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-year {
  width: 100px;
}
</style>
